import * as max from '../max-length-validators';
import * as required from '../required-validators';

export default {
  name: 'postCode',
  label: 'checkout.delivery.address.field.label.postal.code.text',
  required: true,
  validate: [required.postCode, max.lengthPostCode(16)],
};
